import * as THREE from 'three'

import Debug from './Utils/Debug.js'
import Sizes from './Utils/Sizes.js'
import Time from './Utils/Time.js'
import Camera from './Camera.js'
import Mouse from './Utils/Mouse.js'
import Renderer from './Renderer.js'
import World from './World/World.js'
import Resources from './Utils/Resources.js'
import makeDom from './utils/MakeDom.js'

import sources from './sources.js'
import lazySources from './lazySources.js'

let instance = null

export default class Experience
{
    constructor(option)
    {
        // Singleton
        if(instance)
        {
            return instance
        }
        instance = this
        
        // Global access
        window.experience = this

        // Options
        this.canvasContainer = option.canvasContainer
        this.model=option.model
        this.modelA=option.modelA
        this.modelB=option.modelB
        this.modelC=option.modelC
        this.defaultColor=option.defaultColor
        this.canvas = new makeDom({tag:'canvas',class:['webgl'],parent:this.canvasContainer,style:'background-color:#c2c2c2'}).element
        // this.canvas = new makeDom({tag:'canvas',class:['webgl'],parent:this.canvasContainer,style:'background-color:#323a48'}).element
        // console.log(this.canvas)
        // this.setDom()
        this.baseDir = option.baseDir
        this.sources=sources
        this.lazySources=lazySources
        // Setup
        this.debug = new Debug()
        this.sizes = new Sizes()
        this.time = new Time()
        this.mouse = new Mouse({sizes:this.sizes,canvas:this.canvas})
        this.scene = new THREE.Scene()
        this.sceneGroup = new THREE.Group()
        this.sceneGroup.position.z=-20
        this.scene.add(this.sceneGroup)

        this.resources = new Resources(sources,lazySources)
        // this.lazyResources = new Resources(lazySources)
        this.camera = new Camera()
        this.renderer = new Renderer()
        this.world = new World()

        // Resize event
        this.sizes.on('resize', () =>
        {
            this.resize()
        })

        // Time tick event
        this.time.on('tick', () =>
        {
            this.update()
        })
    }
    setDom(){
        // this.loadingBar=new makeDom({tag:'div', class:['loading-bar'],parent:this.canvasContainer})
        // this.loadingText = new makeDom({tag:'div',class:['loading-text'],content:'Loading...', parent:this.canvasContainer})
        // this.loadingGo = new makeDom({tag:'div',class:['go','hided'],content:'GO!', parent:this.canvasContainer})
        // this.loadingSkip = new makeDom({tag:'div',class:['skipintro','hided'],content:'Skip intro', parent:this.canvasContainer})
        // this.goback = new makeDom({tag:'div',class:['goback','hided'],content:'go back', parent:this.canvasContainer})
        // this.neutralButton = new makeDom({tag:'div',class:['neutral','button3d','hided'],content:'neutro', parent:this.canvasContainer})
        // this.stanzaButton = new makeDom({tag:'div',class:['stanza','button3d','hided'],content:'stanza', parent:this.canvasContainer})

        // // loader avanzamento
        // this.eventi.on('loadPercent',(progress)=>{
        //     this.loadingBar.element.style.transform = 'scaleX('+progress+')'
        // })
        
        // // loader completato
        // this.eventi.on('loadAll',()=>{
        //     this.loadingBar.element.style.transform = ``
        //     this.loadingBar.element.classList.add('ended')
        //     this.loadingText.element.classList.add('hided')
        //     this.loadingGo.show()
        //     this.loadingSkip.show()
        //     this.setScenes()
        //     this.setRender()

        // })
        // // console.log(this.eventi)
    }
    resize()
    {
        this.camera.resize()
        this.renderer.resize()
        this.world.definerange()
    }

    update()
    {
        this.camera.update()
        this.world.update()
        this.renderer.update()
    }

    destroy()
    {
        this.sizes.off('resize')
        this.time.off('tick')

        // Traverse the whole scene
        this.scene.traverse((child) =>
        {
            // Test if it's a mesh
            if(child instanceof THREE.Mesh)
            {
                child.geometry.dispose()

                // Loop through the material properties
                for(const key in child.material)
                {
                    const value = child.material[key]

                    // Test if there is a dispose function
                    if(value && typeof value.dispose === 'function')
                    {
                        value.dispose()
                    }
                }
            }
        })

        this.camera.controls.dispose()
        this.renderer.instance.dispose()

        if(this.debug.active)
            this.debug.ui.destroy()
    }
}